(() => {
  if (window.ILProductFormFeedback) return;
  window.ILProductFormFeedback = true;

  let pendingTimer;

  const getDrawer = () => document.querySelector('cart-drawer');
  const hidePending = () => {
    const drawer = getDrawer();
    if (!drawer) return;
    drawer.removeAttribute('aria-busy');
    drawer.classList.remove('is-loading');
    window.clearTimeout(pendingTimer);
  };

  document.addEventListener(
    'submit',
    (event) => {
      if (!event.target.matches('form[data-type="add-to-cart-form"]')) return;

      const drawer = getDrawer();
      if (!drawer || drawer.classList.contains('is-loading')) return;

      const submitter = event.submitter || event.target.querySelector('[type="submit"]');
      drawer.setAttribute('aria-busy', 'true');
      drawer.classList.add('is-loading');
      drawer.open?.(submitter);
      pendingTimer = window.setTimeout(hidePending, 15000);
    },
    true
  );

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => window.requestAnimationFrame(hidePending));
    subscribe(PUB_SUB_EVENTS.cartError, hidePending);
  }
})();
